import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { History, Users, CheckCheck, Smartphone } from "lucide-react";
import { historyNotices } from "../../api/companyNotify";
import { localDateTime } from "../../lib/datetime";

// سجل ما أرسلته الشركة: يُحدَّث تلقائياً بعد كل إرسال عبر حدث "notify:sent".
export const SentHistory = () => {
  const { t, i18n } = useTranslation();
  const ar = (i18n.language || "ar").startsWith("ar");
  const [items, setItems] = useState([]);
  const pick = (a, b) => (ar ? a || b : b || a);

  useEffect(() => {
    const load = () => historyNotices().then(setItems).catch(() => setItems([]));
    load();
    window.addEventListener("notify:sent", load);
    return () => window.removeEventListener("notify:sent", load);
  }, []);

  if (!items.length) return null;
  return (
    <section className="grid gap-4" data-testid="notify-history-card">
      <div className="flex items-center gap-3 px-1">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-background text-primary shadow-neu-sm">
          <History className="h-5 w-5" />
        </span>
        <h2 className="text-lg font-black sm:text-base">{t("notify.historyTitle")}</h2>
      </div>
      <ul className="grid gap-4">
        {items.map((n) => (
          <li key={n.id} className="neu grid gap-1.5 p-5" data-testid={`notify-hist-${n.id}`}>
            <p className="text-base font-black sm:text-sm" dir={ar ? "rtl" : "ltr"}>{pick(n.title_ar, n.title_en)}</p>
            <p className="line-clamp-2 text-sm text-muted-foreground sm:text-xs" dir={ar ? "rtl" : "ltr"}>{pick(n.body_ar, n.body_en)}</p>
            <div className="flex flex-wrap items-center gap-4 text-xs font-bold text-muted-foreground sm:text-[11px]">
              <span className="flex items-center gap-1" data-testid={`notify-hist-recipients-${n.id}`}>
                <Users className="h-3.5 w-3.5" /> {t("notify.histRecipients", { n: n.recipients })}
              </span>
              <span className="flex items-center gap-1 text-primary" data-testid={`notify-hist-read-${n.id}`}>
                <CheckCheck className="h-3.5 w-3.5" /> {t("notify.histRead", { n: n.read })}
              </span>
              <span className="flex items-center gap-1" data-testid={`notify-hist-push-${n.id}`}>
                <Smartphone className="h-3.5 w-3.5" /> {t("notify.histPush", { n: n.push_sent || 0 })}
              </span>
              <span className="font-mono" dir="ltr">{localDateTime(n.at)}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
